const config = {
    baseurl: 'https://api.ai-dog.net',
    baseurlLogo: 'http://logo.ai-dog.net'
    // baseurl: 'http://aidog3'
    // baseurl: 'https://aidog3.jijinit.cn'

}

export default config;
